<template>
  <div>
    <b-row no-gutters class="align-items-center">
      <h1 class="col">Novo Arquivo</h1>
      <b-btn :to="{ name: 'files_list' }" v-if="!hasPeddingFiles">
        Voltar
      </b-btn>
    </b-row>
    <list-files />
  </div>
</template>

<script>
import ListFiles from "../Components/TableList/ListFiles.vue";
import { mapState, mapActions } from "vuex";

export default {
  components: { ListFiles },
  computed: {
    ...mapState("files", ["pedding_files"]),
    hasPeddingFiles() {
      return this.pedding_files > 0;
    },
  },
  methods: {
    ...mapActions("files", ["ActionNewFile"]),
    loadData(id) {
      this.$router.push({ name: "files_edit", params: { id: id } });
    },
  },
  async created() {
    this.ActionNewFile();
  },
};
</script>

<style></style>
